/**
 * Утилита для воспроизведения звуковых эффектов
 */

/**
 * Воспроизводит звук успешной генерации
 */
export const playSuccessSound = () => {
  try {
    const audio = new Audio('/pikly.mp3');
    audio.volume = 0.5; // Устанавливаем громкость на 50%
    audio.play().catch(error => {
      // Игнорируем ошибки воспроизведения (например, если пользователь не взаимодействовал со страницей)
      console.log('Не удалось воспроизвести звук успешной генерации:', error);
    });
  } catch (error) {
    console.log('Ошибка при создании аудио элемента:', error);
  }
};

